module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0105.jpg?v=eed4eee5";